export const FIXED_DELIVERY_HOURS = "9h - 17h";

export const normalizeDeliverySchedule = <TMetadata extends Record<string, unknown>>(metadata: TMetadata) => ({
  ...metadata,
  delivery_schedule_type: "flexible",
  delivery_time_slot: "",
  delivery_schedule_details: "",
});
